import * as React from "react";
import times from "lodash/times";
import { Table, TableRow, TableCell } from "./Table";
import Placeholder from "./Placeholder";

const columnSizing = "100px 1fr 1fr";

const FranchisesListPlaceholder = props => {
  const renderFranchise = iter => {
    return (
      <TableRow key={`job-placeholder-${iter}`} columns={columnSizing}>
        <TableCell>
          <Placeholder style={{ maxWidth: 60 }} />
        </TableCell>
        <TableCell>
          <Placeholder style={{ maxWidth: 200 }} />
        </TableCell>
        <TableCell>
          <Placeholder style={{ maxWidth: 200 }} />
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Table noSideBorders {...props}>
      <TableRow header columns={columnSizing}>
        <TableCell>TTY</TableCell>
        <TableCell>Location Name</TableCell>
        <TableCell>Corporate Name</TableCell>
      </TableRow>
      {times(15, renderFranchise)}
    </Table>
  );
};

export default FranchisesListPlaceholder;



// WEBPACK FOOTER //
// ./src/components/FranchisesListPlaceholder.js